import BranchesService from '../../services/BranchesService';
import toast from 'react-hot-toast';

// Action Types
export const LOADING_TOGGLE_ACTION = '[Branches] Loading Toggle';
export const GET_BRANCHES_SUCCESS = '[Branches] Get Branches Success';
export const GET_BRANCHES_FAILED = '[Branches] Get Branches Failed';
export const GET_BRANCH_BY_ID_SUCCESS = '[Branches] Get Branch By ID Success';
export const GET_BRANCH_BY_ID_FAILED = '[Branches] Get Branch By ID Failed';
export const CREATE_BRANCH_SUCCESS = '[Branches] Create Branch Success';
export const CREATE_BRANCH_FAILED = '[Branches] Create Branch Failed';
export const UPDATE_BRANCH_SUCCESS = '[Branches] Update Branch Success';
export const UPDATE_BRANCH_FAILED = '[Branches] Update Branch Failed';
export const DELETE_BRANCH_SUCCESS = '[Branches] Delete Branch Success';
export const DELETE_BRANCH_FAILED = '[Branches] Delete Branch Failed';
export const GET_BRANCHES_FOR_SELECT_SUCCESS = '[Branches] Get Branches For Select Success';
export const CLEAR_CURRENT_BRANCH = '[Branches] Clear Current Branch';
export const CLEAR_ERRORS = '[Branches] Clear Errors';
export const RESET_BRANCH_SUCCESS = '[Branches] Reset Success State';

// Action Creators
export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export function getBranchesAction(params = {}) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await BranchesService.getAllBranches(params);
            if (response.success) {
                dispatch({
                    type: GET_BRANCHES_SUCCESS,
                    payload: {
                        data: response.data,
                        pagination: response.pagination
                    }
                });
            } else {
                dispatch({
                    type: GET_BRANCHES_FAILED,
                    payload: response.message
                });
            }
        } catch (error) {
            dispatch({
                type: GET_BRANCHES_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch branches'
            });
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function getBranchByIdAction(id) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await BranchesService.getBranchById(id);
            dispatch({
                type: GET_BRANCH_BY_ID_SUCCESS,
                payload: response.data
            });
        } catch (error) {
            dispatch({
                type: GET_BRANCH_BY_ID_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch branch'
            });
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function createBranchAction(branchData, callback) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await BranchesService.createBranch(branchData);
            if (response && response.success === true) {
                dispatch({
                    type: CREATE_BRANCH_SUCCESS,
                    payload: response.data
                });
                dispatch(resetBranchSuccess());
                if (callback && typeof callback === 'function') {
                    callback(response.message || 'Branch created', response.data, true);
                }
            } else {
                dispatch({
                    type: CREATE_BRANCH_FAILED,
                    payload: response.message || 'Failed to create branch'
                });
                if (callback && typeof callback === 'function') {
                    callback(response.message || 'Failed to create branch', response, false);
                }
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to create branch';
            dispatch({
                type: CREATE_BRANCH_FAILED,
                payload: errorMessage
            });
            if (callback && typeof callback === 'function') {
                callback(errorMessage, null, false);
            }
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function updateBranchAction(id, branchData, callback) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await BranchesService.updateBranch(id, branchData);
            if (response && response.success === true) {
                dispatch({
                    type: UPDATE_BRANCH_SUCCESS,
                    payload: response.data
                });
                dispatch(resetBranchSuccess());
                if (callback && typeof callback === 'function') {
                    callback(response.message || 'Branch updated', response.data, true);
                }
            } else {
                dispatch({
                    type: UPDATE_BRANCH_FAILED,
                    payload: response.message || 'Failed to update branch'
                });
                if (callback && typeof callback === 'function') {
                    callback(response.message || 'Failed to update branch', response, false);
                }
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to update branch';
            dispatch({
                type: UPDATE_BRANCH_FAILED,
                payload: errorMessage
            });
            if (callback && typeof callback === 'function') {
                callback(errorMessage, null, false);
            }
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function deleteBranchAction(id) {
    return async (dispatch) => {
        dispatch(loadingToggleAction(true));
        try {
            const response = await BranchesService.deleteBranch(id);
            if (response && response.success === true) {
                dispatch({
                    type: DELETE_BRANCH_SUCCESS,
                    payload: id
                });
                toast.success(response.message || "Branch deleted successfully");
                dispatch(resetBranchSuccess());
                return Promise.resolve();
            } else {
                dispatch({
                    type: DELETE_BRANCH_FAILED,
                    payload: response.message || 'Failed to delete branch'
                });
                toast.error(response.message || "Failed to delete branch");
                return Promise.reject();
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to delete branch';
            dispatch({
                type: DELETE_BRANCH_FAILED,
                payload: errorMessage
            });
            toast.error(errorMessage);
            return Promise.reject();
        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}

export function getBranchesForSelectAction() {
    return async (dispatch) => {
        try {
            const response = await BranchesService.getBranchDropdown();
            if (response.success) {
                dispatch({
                    type: GET_BRANCHES_FOR_SELECT_SUCCESS,
                    payload: response.data
                });
            }
        } catch (error) {
            console.error('Failed to fetch branches for select:', error);
        }
    };
}

export function clearCurrentBranch() {
    return {
        type: CLEAR_CURRENT_BRANCH
    };
}

export function clearErrors() {
    return {
        type: CLEAR_ERRORS
    };
}

export function resetBranchSuccess() {
    return {
        type: RESET_BRANCH_SUCCESS
    };
}